export default __webpack_public_path__ + "media/erin.5cf225c1.jpg";